import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';

const parseDateNoOffset = (dateString) => {
    let date = new Date(dateString);
    date = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    return date;
}

const ApplicantsSummary = (props) => {

    const navigate = useNavigate();

    return (
        <Container className="py-3 border-bottom">
            <Row className="py-1"><Col>Effective Date:</Col><Col>{parseDateNoOffset(props.effectiveDate).toLocaleDateString()}</Col></Row>
            <Row className="py-1"><Col>County:</Col><Col>{props.county}</Col></Row>
            <Row className="py-1"><Col>
                <div>Applicants:</div>
                <ol className="list-unstyled">{props.applicants.map((applicant, i) => {
                    return <li key={i}>{applicant.type} ({applicant.sex === 'male' ? 'Male' : 'Female'}/{applicant.age}{applicant.tobacco ? '/Tobacco' : ''})</li>
                })}</ol>
            </Col></Row>
            <Row className="py-1"><Col><Button size='sm' variant='outline-primary' onClick={() => navigate('/')}>Back</Button></Col></Row>
        </Container>
    )
};

export default ApplicantsSummary;
